import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AuthGuard, CmsConfig, FeaturesConfigModule, I18nModule, OccProductSearchAdapter, UrlModule, provideDefaultConfig } from "@spartacus/core";
import { PageSlotModule, OutletModule, OutletRefModule, MediaModule, AtMessageModule, IconModule, ItemCounterModule, ListNavigationModule, PageComponentModule, SpinnerModule, StarRatingModule, ProductListModule } from "@spartacus/storefront";
import { KbProductListComponent } from "./kb-product-list.component";
import { RouterModule } from "@angular/router";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { KbProductGridItemModule } from "../kb-product-grid-item/kb-product-grid-item.module";
import { KbProductListItemModule } from "../kb-product-list-item/kb-product-list-item.module";
import { MatTabsModule } from '@angular/material/tabs';
import { KbAddToCartModule } from "../../kb-add-to-cart/kb-add-to-cart.module";
import { KbCrossRefModule } from "../kb-cross-ref/kb-cross-ref-list-item.module";
import { KbCrossRefGridItemModule } from "../kb-cross-ref-grid-item/kb-cross-ref-grid-item.module";
import { KbDocumentGridItemModule } from "../kb-document-grid/kb-document-grid.module";
import { KbDocumentListItemModule } from "../kb-document-list/kb-document-list.module";
import { KbSoftwareGridItemModule } from "../kb-software-grid-item/kb-software-grid-item.module";
import { KbSoftwareListItemModule } from "../kb-software-list-item/kb-software-list-item.module";
import { SecureGuard } from "src/app/services/Guards/secure.service";
import { MatDialogModule } from "@angular/material/dialog";
import { FormsModule } from "@angular/forms";
import { CheckAvailabilityDialogComponent } from "../check-availability-dialog/check-availability-dialog.component";
import { FacetNavigationModule } from "../../facet-navigation/facet-navigation.module";
import { KbPaginationModule } from "../../kb-pagination/kb-pagination/kb-pagination.module";
import { KbPipesModule } from "src/app/pipes/kb-pipes.module";
import { KbLoaderModule } from '../../loader/loader.module';

@NgModule({
  imports: [
    AtMessageModule,
    CommonModule,
    FeaturesConfigModule,
    I18nModule,
    IconModule,
    InfiniteScrollModule,
    ItemCounterModule,
    ListNavigationModule,
    MediaModule,
    OutletModule,
    PageComponentModule,
    RouterModule,
    SpinnerModule,
    StarRatingModule,
    UrlModule,
    ProductListModule,
    KbProductGridItemModule,
    KbProductListItemModule,
    MatTabsModule,
    KbAddToCartModule,
    KbCrossRefModule,
    KbCrossRefGridItemModule,
    KbDocumentGridItemModule,
    KbDocumentListItemModule,
    KbSoftwareGridItemModule,
    KbSoftwareListItemModule,
    PageSlotModule,
    MatDialogModule,
    FormsModule,
    FacetNavigationModule,
    KbPaginationModule,
    KbPipesModule,
    KbLoaderModule,
],
  providers: [OccProductSearchAdapter,
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        SearchResultsListComponent: {
          component: KbProductListComponent,
          guards: [SecureGuard],
          data: {
            composition: {
              inner: ['ProductAddToCartComponent'],
            },
          },
        },

      }
    })
  ],
  exports: [KbProductListComponent],
  declarations: [KbProductListComponent, CheckAvailabilityDialogComponent]
})
export class KbProductListModule {

}
